import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "@src/api/config";
import { RoleEnum } from "@src/custom-types";
import { showModalSuccess } from "@src/redux/modalTypeSuccess";
import { AppDispatch, RootState } from "@src/redux/store";

export const checkEmployeesMassive = createAsyncThunk<
  any,
  any,
  {
    dispatch: AppDispatch;
    state: RootState;
  }
>("clients/checkEmployeesMassive", async (params, thunkApi) => {
  const state = thunkApi.getState();
  const products = state.products as { productSelected: { value: any } };
  const businessLines = state.businessLines as {
    businessLineSelected: { id: any };
  };

  const response = await api.post(`api/clients/employee/mass`, {
    ...params,
    product: products.productSelected.value,
    business_line: businessLines.businessLineSelected.id
  });

  return response.data;
});

export const saveEmployeesMassive = createAsyncThunk<
  any,
  any,
  {
    dispatch: AppDispatch;
    state: RootState;
  }
>("clients/saveEmployeesMassive", async (params, thunkApi) => {
  const { dispatch } = thunkApi;
  const state = thunkApi.getState();
  const products = state.products as { productSelected: { value: any } };
  const businessLines = state.businessLines as {
    businessLineSelected: { id: any };
  };

  const response = await api.post(`api/clients/employee/mass/save`, {
    ...params,
    employees: state.clientsEmployees.validatedEmployees.map((employee) => {
      return {
        ...employee,
        taxData: employee.taxData.value,
        group: employee.group.value
      };
    }),
    product: products.productSelected.value,
    business_line: businessLines.businessLineSelected.id
  });

  let url = `/users/clients/show/${params.clientId}`;

  switch (state.auth.userData?.role) {
    case RoleEnum.SELLER:
      url = `/seller/clients/show/${params.clientId}`;
      break;
    case RoleEnum.CLIENT:
      url = `/settings`;
  }

  dispatch(
    showModalSuccess({
      message:
        "Empleados cargados con éxito.",
      url
    })
  );

  return {
    params,
    data: response.data
  };
});